/**
 * FIXERLIGHT-268 : un réparateur qui se déplace peut ne publier que son code
 * postal et sa ville (son point de départ est souvent son domicile). L'api ne
 * sert alors plus la rue (`address: null`) ni de coordonnées précises, et le
 * dit par `address_public: false` ; elle joint `service_area`, la zone
 * d'intervention que le pro a écrite dans ses Réglages.
 *
 * Pur et défensif comme `bookingState` : une fiche sans `address_public`
 * (aperçu branché sur une api en retard) est une adresse publiée, comme avant.
 */

/** Vrai seulement quand l'api dit explicitement que l'adresse est masquée. */
export const adresseMasquee = (shop) => !!shop && shop.address_public === false;

/** « 75020 Paris · Paris Est (11e, 19e, 20e) », la zone seulement si renseignée. */
export const lieuApproximatif = (shop) => {
  if (!shop) return '';
  const ville = [shop.postal_code, shop.city].filter(Boolean).join(' ');
  const zone =
    typeof shop.service_area === 'string' ? shop.service_area.trim() : '';
  return [ville, zone].filter(Boolean).join(' · ');
};
